import { render, staticRenderFns } from "./NavTabBar.vue?vue&type=template&id=33d15d90&scoped=true"
import script from "./NavTabBar.vue?vue&type=script&lang=js"
export * from "./NavTabBar.vue?vue&type=script&lang=js"
import style0 from "./NavTabBar.vue?vue&type=style&index=0&id=33d15d90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d15d90",
  null
  
)

export default component.exports